module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Tambah Pembayaran Pending ")]), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [(_vm.paymentPendingId) ? [_c('PaymentPendingRowCard', {
    attrs: {
      "paymentPendingId": _vm.paymentPendingId,
      "isSpecialMarking": _vm.isSpecialMarking
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.isLoadingContent) ? _c('Spin', {
    attrs: {
      "size": "large"
    }
  }) : _c('div', [_c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    attrs: {
      "disabled": "",
      "readonly": "",
      "type": "date",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [(_vm.searchSelectSubbranch == 'JKT') ? _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                                " + _vm._s(subbranch.subbranchname) + "\n                            ")])
  }), 1) : _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                                " + _vm._s(subbranch.subbranchname) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" \n                        ")]), _vm._v(" "), (_vm.paymentDate != '' && (_vm.paymentPendingMarking || _vm.paymentPendingMarkingGroup)) ? _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large",
      "disabled": ""
    },
    model: {
      value: (_vm.isGroup),
      callback: function($$v) {
        _vm.isGroup = $$v
      },
      expression: "isGroup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1) : _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroup),
      callback: function($$v) {
        _vm.isGroup = $$v
      },
      expression: "isGroup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == false && _vm.paymentPendingId && _vm.paymentPendingMarking),
      expression: "paymentDate != '' && isGroup == false && paymentPendingId && paymentPendingMarking"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.paymentPendingMarking),
      callback: function($$v) {
        _vm.paymentPendingMarking = $$v
      },
      expression: "paymentPendingMarking"
    }
  })], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == false && _vm.paymentPendingId && _vm.paymentPendingMarking == ''),
      expression: "paymentDate != '' && isGroup == false && paymentPendingId && paymentPendingMarking == ''"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "disabled": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": _vm.getInvoiceData
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.label) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == true && _vm.paymentPendingId && _vm.paymentPendingMarkingGroup),
      expression: "paymentDate != '' && isGroup == true && paymentPendingId && paymentPendingMarkingGroup"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.paymentPendingMarkingGroup),
      callback: function($$v) {
        _vm.paymentPendingMarkingGroup = $$v
      },
      expression: "paymentPendingMarkingGroup"
    }
  })], 1), _vm._v(" "), (_vm.paymentDate != '' && _vm.isGroup == true && _vm.paymentPendingId && _vm.paymentPendingMarkingGroup == '') ? _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "Ketik Group Name",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": _vm.getInvoiceDataByGroupMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.label) + "\n                            ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1",
      "offset": "1"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetPayment),
      expression: "loadingGetPayment"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "30%"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Klaim",
      "prop": "claim"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "Masukan Klaim yang sesuai dengan Mutasi",
      "filterable": "",
      "multiple": "",
      "disabled": _vm.optionClaims.length === 0
    },
    model: {
      value: (_vm.claims),
      callback: function($$v) {
        _vm.claims = $$v
      },
      expression: "claims"
    }
  }, _vm._l((_vm.optionClaims), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info",
      "icon": "ios-refresh",
      "loading": _vm.loadingGetClaims
    },
    on: {
      "click": _vm.getClaims
    }
  }, [_vm._v("Refresh Klaim")])], 1), _vm._v(" "), (_vm.isSpecialMarking) ? _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.depositRemaining != 0),
      expression: "paymentDate != '' && markingIdSelected != '' && depositRemaining != 0"
    }],
    attrs: {
      "label": "Total Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currencyInter")(_vm.depositRemaining)) + "\n                    ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                        " + _vm._s(_vm._f("currencyInter")(_vm.totalUseDepositAmount)) + " - LEBIH\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                        Terpakai: " + _vm._s(_vm._f("currencyInter")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currencyInter")((_vm.depositRemaining -
    _vm.totalUseDepositAmount))) + "\n                    ")]) : _vm._e()], 1) : _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.depositRemaining != 0),
      expression: "paymentDate != '' && markingIdSelected != '' && depositRemaining != 0"
    }],
    attrs: {
      "label": "Total Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.depositRemaining)) + "\n                    ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                        " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + " - LEBIH\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                        Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositRemaining -
    _vm.totalUseDepositAmount))) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositMutasiRemaining),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining"
    }],
    attrs: {
      "label": "Total Mutasi Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currencyInter")(_vm.depositMutasiRemaining)) + "\n                    ")]), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi > _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                        Terpakai\n                        " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + " - LEBIH\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                        Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositMutasiRemaining -
    _vm.totalUseDepositMutasi))) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isSpecialMarking) ? _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }],
    attrs: {
      "label": 'Deposit ' + _vm.selectGroup
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currencyInter")(_vm.groupDepositRemaining)) + "\n                    ")])], 1) : _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }],
    attrs: {
      "label": 'Deposit ' + _vm.selectGroup
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.groupDepositRemaining)) + "\n                    ")])], 1), _vm._v(" "), (_vm.isSpecialMarking) ? _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.amountReceived),
      callback: function($$v) {
        _vm.amountReceived = $$v
      },
      expression: "amountReceived"
    }
  }, 'money', _vm.moneyInter, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountResidue != 0),
      expression: "amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                        Selisih   " + _vm._s(_vm._f("currencyInter")(_vm.amountResidue)) + "\n                    ")])], 1) : _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.amountReceived),
      callback: function($$v) {
        _vm.amountReceived = $$v
      },
      expression: "amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountResidue != 0),
      expression: "amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                        Selisih   " + _vm._s(_vm._f("currency")(_vm.amountResidue)) + "\n                    ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.creditRound > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && creditRound > 0"
    }],
    attrs: {
      "label": "Chart of Account"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.coaId),
      callback: function($$v) {
        _vm.coaId = $$v
      },
      expression: "coaId"
    }
  }, _vm._l((_vm.COAs), function(coa) {
    return _c('Option', {
      key: coa.id,
      attrs: {
        "value": coa.id
      }
    }, [_vm._v(_vm._s(coa.account_name))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Uang Potongan"
    }
  }, [(_vm.isSpecialMarking) ? _c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.discountReceived),
      callback: function($$v) {
        _vm.discountReceived = $$v
      },
      expression: "discountReceived"
    }
  }, 'money', _vm.moneyInter, false)) : _c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.discountReceived),
      callback: function($$v) {
        _vm.discountReceived = $$v
      },
      expression: "discountReceived"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId == null),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId == null"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("\n                       \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "discount",
      "value": "disc"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "disc")
    },
    on: {
      "change": function($event) {
        _vm.category = "disc"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "discount"
    }
  }, [_vm._v("Potongan")])]), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("\n                       \n                ")]), _vm._v(" "), (_vm.isSpecialMarking) ? _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0),
      expression: "depositAmount != 0"
    }],
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Kelebihan\n                    : " + _vm._s(_vm._f("currencyInter")(_vm.depositAmount)))]) : _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0),
      expression: "depositAmount != 0"
    }],
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Kelebihan :\n                    " + _vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isbalanceAmount && !_vm.loadingGetPayment),
      expression: "!isbalanceAmount && !loadingGetPayment"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n                    Tidak dapat melanjutkan proses pembayaran jika Uang Diterima tidak sama dengan Mutasi.\n                    "), _c('strong', [_vm._v("Selisih : " + _vm._s(_vm._f("currencyInter")(_vm.diffAmount)))])]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optionClaims.length == 0),
      expression: "optionClaims.length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                    Tidak ada Klaim pada hari ini untuk Marking ini")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0 && _vm.category == 'disc'),
      expression: "depositAmount != 0 && category == 'disc'"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v(" Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.")]), _vm._v(" "), (_vm.isSpecialMarking) ? _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup && !_vm.loadingGetPayment),
      expression: "isGroup && !loadingGetPayment"
    }]
  }, [_vm._v("Total Alokasi Marking " + _vm._s(_vm.selectGroup) + " : " + _vm._s(_vm._f("currencyInter")(_vm.totalAmountSelect)))]) : _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup && !_vm.loadingGetPayment),
      expression: "isGroup && !loadingGetPayment"
    }]
  }, [_vm._v("Total Alokasi Marking " + _vm._s(_vm.selectGroup) + " :\n                    " + _vm._s(_vm._f("currency")(_vm.totalAmountSelect)))])], 1)], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0 && _vm.receivableGroup == ''),
      expression: "this.invoiceDues.length > 0 && receivableGroup == ''"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Daftar Invoices ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [
    [_c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v(" Tgl Bongkar ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v(" Potongan ")])]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.paymentPendingMarking.includes('SBR/') || _vm.paymentPendingMarking.includes('SBRT/') || _vm.paymentPendingMarking.includes('CTH/')) ? _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePaymentDecimal', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0) : _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePayment', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0)])], 1), _vm._v(" "), (_vm.receivableGroup != '') ? _c('Card', [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.groupClickHandle
    }
  }, _vm._l((_vm.receivableGroup), function(marking) {
    return _c('TabPane', {
      key: marking.markingheadercode,
      attrs: {
        "label": marking.markingheadercode
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" Daftar Invoice ")]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg",
      attrs: {
        "type": "flex"
      }
    }, [
      [_c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v(" Tgl Bongkar")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "5"
        }
      }, [_vm._v(" Potongan ")])]
    ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.paymentPendingMarkingGroup.includes('SBR/') || _vm.paymentPendingMarkingGroup.includes('SBRT/') || _vm.paymentPendingMarkingGroup.includes('CTH/')) ? _c('div', _vm._l((marking.invoiceDue), function(invoiceDue) {
      return _c('div', {
        key: invoiceDue.id
      }, [_c('cInvoicePaymentDecimal', {
        attrs: {
          "invoiceDue": invoiceDue,
          "depositRemaining": _vm.depositRemaining,
          "depositMutasiRemaining": _vm.depositMutasiRemaining,
          "paymentPendingId": _vm.paymentPendingId,
          "paymentPendingAmount": _vm.paymentPendingAmount
        },
        on: {
          "setAllocateAmount": _vm.setAllocateAmount
        }
      }), _vm._v(" "), _c('br')], 1)
    }), 0) : _c('div', _vm._l((marking.invoiceDue), function(invoiceDue) {
      return _c('div', {
        key: invoiceDue.id
      }, [_c('cInvoicePayment', {
        attrs: {
          "invoiceDue": invoiceDue,
          "depositRemaining": _vm.depositRemaining,
          "depositMutasiRemaining": _vm.depositMutasiRemaining,
          "paymentPendingId": _vm.paymentPendingId,
          "paymentPendingAmount": _vm.paymentPendingAmount
        },
        on: {
          "setAllocateAmount": _vm.setAllocateAmount
        }
      }), _vm._v(" "), _c('br')], 1)
    }), 0)])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false),
      expression: "isGroup == false"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) ||
          ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) &&
        _vm.paymentPendingId == null && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||\n                ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0))\n            && paymentPendingId == null && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.isbalanceAmount),
      expression: "isGroup == false && isbalanceAmount"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' &&
        (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) ||
          ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) &&
        ((_vm.depositAmount == 0 && _vm.category == 'disc') || (_vm.depositAmount >= 0 && _vm.category == 'pay')) &&
        ((_vm.paymentPendingId && _vm.depositAmount <= _vm.paymentPendingAmount) || _vm.paymentPendingId == null) &&
        (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' &&\n            (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||\n                ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) &&\n            ((depositAmount == 0 && category == 'disc') || (depositAmount >= 0 && category == 'pay')) &&\n            ((paymentPendingId && depositAmount <= paymentPendingAmount) || paymentPendingId == null) &&\n            (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentPending
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup && _vm.isbalanceAmount),
      expression: "isGroup && isbalanceAmount"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && ((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.depositType = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDeposit),
      callback: function($$v) {
        _vm.modalConfirmDeposit = $$v
      },
      expression: "modalConfirmDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v("\n        Kelebihan "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" akan dijadikan sebagai :\n        "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "DFM"
    }
  }, [_c('span', [_vm._v("Deposit")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "PRF"
    }
  }, [_c('span', [_vm._v("Pendapatan")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentPendingId == null),
      expression: "isGroup == false && paymentPendingId == null"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentPendingId),
      expression: "isGroup == false && paymentPendingId"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentPending
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modalConfirmAutoDeposit),
      callback: function($$v) {
        _vm.modalConfirmAutoDeposit = $$v
      },
      expression: "modalConfirmAutoDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('p', [_vm._v("\n            Marking tidak memiliki piutang, apakah mutasi dengan Total : "), _c('b', [_vm._v(" Rp. " + _vm._s(_vm._f("currency")(_vm.paymentPendingAmount)) + " ")]), _vm._v("\n            ingin dijadikan sebagai "), _c('b', [_vm._v("Deposit")]), _vm._v(" ?\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        _vm.modalConfirmAutoDeposit = false
      }
    }
  }, [_vm._v("Batalkan")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postReceivableAsDeposit
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Tambahkan")]) : _c('span', [_vm._v("Mohon tunggu...")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5137d4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentPendingAdd.vue
// module id = 1806
// module chunks = 1